<template>
  <footer
    class="footer-main branding-bg"
    data-trackname="footer"
  >
    <div class="container">
      <p>© {{ year }} BMAT</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Vuefooter",
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
